var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 2,
  clipPath: "url(#searchIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "m7 17-6 6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 10,
  r: 9
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "searchIcon_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: "1em",
  height: "1em",
  fill: "#fff"
})))));
export default SvgSearchIcon;